import FormComponent from '../../utils/FormComponent';
import ModalDialog from '../../utils/ModalDialog';
import React from 'react';
import * as api from '../../../api/permissions-api';
import * as viewUtils from '../../../utils/view-utils';
import i18next from 'i18next';
import * as blockUtils from '../../../utils/BlockUtils';
import PropTypes from 'prop-types';
import PermissionsMatrix from './PermissionsMatrix';

class PermissionsForm extends FormComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.updateUserPermission = this.updateUserPermission.bind(this);
    this.getPermissionsForUser = this.getPermissionsForUser.bind(this);
    this.resetUserToDefaultPermissions = this.resetUserToDefaultPermissions.bind(this);

    this.state = {
      value: 0,
      permissionResponse: null,
      showChangesAppliedPrompt: false,
    };
  }

  initialState() {
    return {
      user: this.props.user,
      dialogId: this.props.dialogId,
      permissionResponse: null,
    };
  }

  componentDidMount() {
    this.getPermissionsForUser();
  }

  getPermissionsForUser() {
    blockUtils.blockUI();
    api.getEffectivePermissionsForUser(this.props.user.id).then((response) => {
      const permissionResponse = response.data;

      blockUtils.unblockUI();
      this.setState({
        permissionResponse: permissionResponse,
      });
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  resetUserToDefaultPermissions() {
    confirm(
        () => {
          blockUtils.blockUI();
          api.resetPermissionsToDefaultForUser(this.props.user.id).then(() => {
            blockUtils.unblockUI();

            this.setState({
              permissionResponse: null,
            });

            this.showChangesAppliedPrompt();
            this.getPermissionsForUser();
          }).catch((error) => {
            blockUtils.unblockUI();
            window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
          });
        },
        i18next.t('users.permissions.reset_to_default'),
    );
  }

  updateUserPermission(updatedPermission) {
    // updatedPermission = {name, allowed}
    const permissionResponse = this.state.permissionResponse;
    for (let i = 0; i < permissionResponse.permissionSections.length; i++) {
      for (let j = 0; j < permissionResponse.permissionSections[i].permissions.length; j++) {
        if (permissionResponse.permissionSections[i].permissions[j].name === updatedPermission.name) {
          permissionResponse.permissionSections[i].permissions[j].allowed = !permissionResponse.permissionSections[i].permissions[j].allowed;
          this.setState({permissionResponse: permissionResponse});
        }
      }
    }

    blockUtils.blockUI();
    api.updatePermissionsForUser(this.props.user.id, updatedPermission).then((response) => {
      blockUtils.unblockUI();
      if (response.status !== 202) {
        window.showAlert(i18next.t('error'), response.statusText);
        return;
      }

      this.showChangesAppliedPrompt();
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  showChangesAppliedPrompt() {
    this.setState({showChangesAppliedPrompt: true});

    setTimeout(() => {
      this.setState({showChangesAppliedPrompt: false});
    }, 2000);
  }

  handleChange(event, newValue) {
    this.setState({
      value: newValue,
    });
  }

  render() {
    const role = this.state.permissionResponse? i18next.t(`users.roles.${this.state.permissionResponse.role}`) : 'Unknown';
    const title = this.state.permissionResponse ? i18next.t('users.permissions.title', {name: this.state.permissionResponse.username, role: role}) : 'Unknown';

    return (
      <ModalDialog
        customClass="permissions-form"
        modalTitle={title}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        showSave={false}
        customStyle={{width: '1000px'}}
        showCustomButton={true}
        customButtonText={'Reset to default Permissions'}
        customButtonSubmit={this.resetUserToDefaultPermissions}
        showSavePrompt={true}
        showChangesAppliedPrompt={this.state.showChangesAppliedPrompt}
      >
        <PermissionsMatrix
          user={this.props.user}
          permissionSections={this.state.permissionResponse ? this.state.permissionResponse.permissionSections : null}
          onChange={this.updateUserPermission}
        />
      </ModalDialog>
    );
  }
}

PermissionsForm.propTypes = {
  value: PropTypes.number,
  user: PropTypes.object,
  dialogId: PropTypes.string,
  permissionResponse: PropTypes.object,
};

export default PermissionsForm;
